import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./locales/en.json";
import si from "./locales/si.json";
import ta from "./locales/ta.json";

// Trilingual from day one (1). Strings live in JSON locale files, never in
// components. The detector persists the choice in localStorage; the
// LanguageSwitcher writes the same key.
export const SUPPORTED = ["en", "si", "ta"] as const;
export type Lang = (typeof SUPPORTED)[number];

export const LANG_LABELS: Record<Lang, string> = {
  en: "EN",
  si: "සිං",
  ta: "த",
};

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      si: { translation: si },
      ta: { translation: ta },
    },
    fallbackLng: "en",
    supportedLngs: SUPPORTED as unknown as string[],
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "klutch-lang",
      caches: ["localStorage"],
    },
  });

export default i18n;
